import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Endpoints } from '../../core/enums/endpoints';

@Injectable({
  providedIn: 'root',
})
export class ContactUsService {
  constructor(
    private httpclient: HttpClient 
  ) {}

  sendMessage(data: any) {
    return this.httpclient.post(`${environment.apiUrl}${Endpoints.CONTACT_US}`, data);
  }
}
